import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import './Overlay.css'

const Overlay = props => {
  const className = classnames({
    Overlay: true,
    'Overlay-hidden': !props.visible,
    'Overlay-transparent': !!props.transparent,
    'Overlay-clickable': !!props.onClick
  })
  return (
    <div className={className} onClick={props.onClick}>
      {props.children}
    </div>
  )
}

Overlay.displayName = 'Overlay'

Overlay.propTypes = {
  visible: PropTypes.bool,
  transparent: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node
}

export default Overlay



// WEBPACK FOOTER //
// ./ui/Overlay.js